import { useEffect, useState } from "react";
import firebaseService from "../firebase_service/firebaseService";
import DSBox from "views/system-design/DSBox";
import DSStack from "views/system-design/DSStack";
import DSTypography from "views/system-design/DSTypography";
import DSPrimaryButton from "views/system-design/DSPrimaryButton";
import DSCircularProgress from "views/system-design/DSCircularProgress";
import logo from "assets/img/Klydoclock_logo.svg";

const ALLOWED_ROLES = ["admin", "viewer"];

function SplashScreen() {
  return (
    <DSBox
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "background.default",
      }}
    >
      <DSStack spacing={4} alignItems="center">
        <img width="180" src={logo} alt="Klydo" />
        <DSCircularProgress color="primary" />
      </DSStack>
    </DSBox>
  );
}

const ErrorScreen = (err: string) => (
  <DSBox
    sx={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "background.default",
      p: 2,
    }}
  >
    <DSStack spacing={3} alignItems="center">
      <img width="180" src={logo} alt="Klydo" />
      <DSTypography variant="h6" textAlign="center">
        {err || "Oops... something went wrong"}
      </DSTypography>
      <DSPrimaryButton href="/login">Return to Login</DSPrimaryButton>
    </DSStack>
  </DSBox>
);

function withSplashScreen(WrappedComponent: any) {
  return () => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(false);
    const [error, setError] = useState<{ error: string }>();
    useEffect(() => {
      firebaseService.onAuthStateChanged(
        (authUser: firebase.default.User | undefined) => {
          if (!authUser) {
            setUser(false);
            setLoading(false);
            return;
          }
          authUser.getIdTokenResult().then((token) => {
            if (ALLOWED_ROLES.includes(token.claims.role)) {
              setUser(true);
              setLoading(false);
            } else {
              firebaseService.logOut();
              setError({ error: "User doesn't have permission" });
              setLoading(false);
            }
            setLoading(false);
          });
        },
      );
    }, []);
    // while checking user session, show "loading" message
    if (loading) return SplashScreen();

    if (error) return ErrorScreen(error.error || "");

    // otherwise, show the desired route
    return <WrappedComponent isLoggedIn={user} />;
  };
}

export default withSplashScreen;
